export default "__VITE_ASSET__Dq0ldncP__"